import * as yup from "yup";
import i18next from "config/i18next";
import { AnyObject } from "yup/lib/types";
import { validateHourDifference } from "utils/validations";
import { t } from "i18next";

const requiredMessage = i18next.t("validations:required");
const optionalString = yup.string().optional();
const requiredPositiveNumber = yup
  .number()
  .test(
    "positiveNumber",
    i18next.t("validations:positiveNumber"),
    (value) => !!(value && value > 0)
  )
  .required(requiredMessage);

const validationHourParams = {
  minDifference: 60,
  field: "deliveryOperationTime.end",
  minMessage: i18next.t("polygonGeneral:minimumOneHour"),
};

const validateOperationTime = (context: yup.TestContext<AnyObject>) =>
  validateHourDifference(context, validationHourParams);

const validateMaxTrip = (
  context: yup.TestContext<AnyObject>,
  value?: number
) => {
  if (!context.parent.enable) return true;
  if (value === 0)
    return context.createError({
      message: t("validations:positiveNumber"),
    });
  if (!value)
    return context.createError({
      message: requiredMessage,
    });
  return true;
};

const distance = yup.object({
  maxDistanceForBoundary: requiredPositiveNumber,
  maxBetweenPoints: requiredPositiveNumber,
});

const deliveryOperationTime = yup.object({
  initial: yup
    .string()
    .test("timeValidation", (value, context) => validateOperationTime(context))
    .required(requiredMessage),
  end: yup
    .string()
    .test("timeValidation", (value, context) => validateOperationTime(context))
    .required(requiredMessage),
});
const pickUpMaxCapacity = requiredPositiveNumber.max(
  30,
  i18next.t("polygonGeneral:pickUpMaxCapacityAmountError")
);
const trip = yup.object({
  enable: yup.boolean(),
  maximumTravelDistance: yup
    .number()
    .test("tripValidation", (value, context) =>
      validateMaxTrip(context, value)
    ),
});

export const validationSchema = yup.object({
  id: optionalString,
  distance,
  deliveryOperationTime,
  pickUpMaxCapacity,
  trip,
});
